import { createContext } from "react";
const SocialMediaMultipageContext = createContext({});
export default SocialMediaMultipageContext;
